import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./ThumbsDownButton.module.css";
import thumbsUp from "./thumbsUp.png";

/**
 * Interactive component, A button that the user clicks on to give a thumbs down vote to a decision item. (Goes to the Decision Page if clicked on from the Agenda Page)
 */
export function ThumbsDownButton({ isLocked, isGrayed, onClick }) {
  return (
    <div onClick={isLocked ? null : onClick}>
      <button
        className={classNames(
          styles.imageContainer,
          isGrayed ? styles.grayBg : styles.redBg,
          isLocked ? styles.noPointerOnHover : styles.cursorPointerOnHover
        )}
      >
        <img src={thumbsUp} className={classNames(styles.image)} />
      </button>
    </div>
  );
}

ThumbsDownButton.propTypes = {
  isLocked: PropTypes.bool,
  isGrayed: PropTypes.bool,
  onClick: PropTypes.func,
};
